/**
 * Resolve activity id from route params, query, or pathname.
 * Supports:
 * - /a/1
 * - /a/1/lessons
 * - /#/a/1
 * - /?id=1
 * - /a/1#/  (path before hash when still on hash router)
 */
export function resolveActivityId(route) {
  if (route && route.params && route.params.activityId) {
    return String(route.params.activityId)
  }

  if (route && route.query && route.query.id) {
    return String(route.query.id)
  }

  if (typeof window === 'undefined') {
    return ''
  }

  const params = new URLSearchParams(window.location.search)
  const queryId = params.get('id')
  if (queryId) {
    return String(queryId)
  }

  const hash = window.location.hash || ''
  const hashPath = hash.replace(/^#/, '') || '/'
  const hashMatch = hashPath.match(/^\/a\/([^/]+)/)
  if (hashMatch) {
    return decodeURIComponent(hashMatch[1])
  }

  const pathMatch = (window.location.pathname || '').match(/^\/a\/([^/]+)/)
  if (pathMatch) {
    return decodeURIComponent(pathMatch[1])
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/utils/activity-route.js